module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('show-code', [_c('div', {
    slot: "showcase"
  }, [_c('v-alert', {
    attrs: {
      "info": "",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n            This is a success alert that is closable.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(!_vm.alert) ? _c('v-btn', {
    attrs: {
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.alert = true
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    slot: "onlycode"
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('show-code')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ec0d74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/onlyone/pages/ui/alerts.vue
// module id = 760
// module chunks = 1